/*
* @Author: Abhi Bhatt
* @Date:   2020-06-09 18:13:45
* @Last Modified by:   babysoft08
* @Last Modified time: 2025-09-22 21:33:01
*/
import React from 'react';
import {Switch, Route, useLocation } from 'react-router-dom';
import Home from '../../pages/Home/Home';
import OldDownloads from '../../pages/Downloads/OldDownloads';
import Downloads from '../../pages/Downloads/Downloads';
import News from '../../pages/News/News';
import Category from '../../pages/Category/Category';
import Product from '../../pages/Product/Product';
import ProductDetail from '../../pages/Product/ProductDetail';
import ProductInventory from '../../pages/Product/ProductInventory';
import Motor from '../../pages/Motor/Motor';
import Support from '../../pages/Support/Support';
import MotorInventory from '../../pages/Motor/MotorInventory';
import MotorInventoryOld from '../../pages/Motor/MotorInventoryOld';
import Contact from '../../pages/Contact/Contact';
import ContactDetails from '../../pages/Contact/ContactDetails';
import Location from '../../pages/Location/Location';
import LocationDetails from '../../pages/Location/LocationDetails';
import CheckLogin from '../../pages/CheckLogin/CheckLogin';
import Login from '../../pages/User/Login';
import SignUp from '../../pages/User/SignUp';
import ForgotPassword from '../../pages/User/ForgotPassword';
import Confirmation from '../../pages/User/Confirmation';
import ResetPassword from '../../pages/User/ResetPassword';
import SearchMotor from '../../pages/Search/SearchMotor';
import SearchMotorInventory from '../../pages/Search/SearchMotorInventory';
import ProtectedRoute from '../../ProtectedRoute';
import TrackShipment from '../../pages/Shipment/TrackShipment';
import TrackShipmentOld from '../../pages/Shipment/TrackShipmentOld';
import MyAccount from '../../pages/User/MyAccount';
import OrderHistory from '../../pages/User/OrderHistory';
import OpenOrders from '../../pages/User/OpenOrders';
import ScrollToTop from '../../js/scrollToTop';
import QualityControl from '../../pages/QualityControl/QualityControl';
import QualityControlStatus from '../../pages/QualityControl/QualityControlStatus';
import RepPortal from '../../pages/StaticPage/RepPortal';
import NetPricingReport from '../../pages/NetPricing/NetPricingReport';
import StaticPage from '../../pages/StaticPage/StaticPage';
import NotFound from '../../pages/NotFound/NotFound';
import PrintLabel from '../../pages/PrintLabel/PrintLabel';
import CatalogRequest from '../../pages/Downloads/CatalogRequest.js';
import CatalogRequestConfirmation from '../../pages/Downloads/CatalogRequestConfirmation.js';

const RESERVED_PATHS = [
	'portal',
	'qcontrol',
	'ware1234555566'
];


function ConditionalSlugOr404() {
  const location = useLocation();
  const permalink = location.pathname.split('/')[1]; // first segment
  if (permalink && !RESERVED_PATHS.includes(permalink)) {
    return <StaticPage permalink={permalink}/>;
  }

  return <NotFound />;
}

function Main() {
	return (
		<main>
			<ScrollToTop />
			<Switch>
				<Route exact path='/' component={Home} />
				<Route exact path='/support' component={Support} />
				<Route exact path='/old-downloads' component={OldDownloads} />
				<Route exact path='/downloads' component={Downloads} />
				<Route exact path='/downloads/:permalink' component={Downloads} />
				<Route exact path="/categories/:permalink" component={Category} />
				<Route exact path="/products" component={Product} />
				<Route exact path="/products/:permalink" component={ProductDetail} />
				<ProtectedRoute exact path="/products/:permalink/inventory" component={ProductInventory} />
				<Route exact path="/motors/:part_number" component={Motor} />
				<Route exact path="/motors/:part_number/inventory" component={MotorInventory} />
				<Route exact path='/contact' component={Contact} />
				<Route exact path='/contact/:route' component={ContactDetails} />
				<ProtectedRoute exact path='/locations' component={Location} />
				<Route exact path='/location/:permalink' component={LocationDetails} />
				<Route exact path='/user/login' component={Login} />
				<Route exact path='/user/sign-up' component={SignUp} />
				<Route exact path='/user/forgot-password' component={ForgotPassword} />
				<Route exact path='/user/confirmation' component={Confirmation} />
				<Route exact path='/user/confirmation/:confirmationToken' component={Confirmation} />
				<Route exact path="/user/reset-password/:resetPasswordToken" component={ResetPassword} />
				<Route exact path="/search-motor/" component={SearchMotor} />
				<Route exact path="/search-motor-inventory/" component={SearchMotorInventory} />
				<Route exact path="/motors/:part_number/inventory/old" component={MotorInventoryOld} />
				<ProtectedRoute exact path='/track-shipment' component={TrackShipment} />
				<Route exact path='/track-shipment-old' component={TrackShipmentOld} />
				<Route exact path="/quality-control" component={QualityControl} />
				<Route exact path="/quality-control-status" component={QualityControlStatus} />
				<ProtectedRoute exact path="/user/my-account" component={MyAccount} />
				<ProtectedRoute exact path="/user/order-history" component={OrderHistory} />
				<ProtectedRoute exact path="/user/open-orders" component={OpenOrders} />
				{/* <Route exact path='/repportal' component={RepPortal} /> */}
				<ProtectedRoute exact path="/net-pricing-reports" component={NetPricingReport} />
				<Route exact path='/print-pallet-label' component={PrintLabel} />
				<Route exact path="/catalog-request" component={CatalogRequest} />
				<Route exact path="/catalog-request-confirmation" component={CatalogRequestConfirmation} />

				<Route component={ConditionalSlugOr404} />
			</Switch>
		</main>
	);

}


export default Main;